import CreateSuggestedPostPage from './CreateSuggestedPostPage';
export default CreateSuggestedPostPage;
